<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'

export default {
  components: {
    Chart
  },
  data() {
    return {
      cdata: {
        projects: [
          { name: '梁堂一期项目', labor: 4, professional: 0, material: 13, consulting: 0 },
          { name: '大学路实验学校西（XT2024-16号）地块', labor: 1, professional: 0, material: 2, consulting: 0 },
          { name: '徐州安科园餐厅装修改造项目', labor: 1, professional: 0, material: 6, consulting: 0 },
          { name: '民主南路综合楼', labor: 2, professional: 0, material: 2, consulting: 0 },
          { name: '徐州铜山汽车客运站', labor: 1, professional: 0, material: 2, consulting: 0 },
          { name: '徐州云镜上庄茶店装修改造项目', labor: 3, professional: 0, material: 5, consulting: 0 },
          { name: '徐州望城菜市场二层装修改造项目', labor: 2, professional: 0, material: 9, consulting: 0 },
          { name: '徐州望城菜市场三层隔墙及设备改造工程', labor: 1, professional: 0, material: 1, consulting: 0 },
          { name: '恒清第三方维修', labor: 2, professional: 0, material: 1, consulting: 0 },
          { name: '硕丰第三方维修', labor: 2, professional: 0, material: 1, consulting: 0 },
          { name: '2019-1号地块1#、2#楼公共区域及部分楼层装修项目材料采购', labor: 0, professional: 0, material: 9, consulting: 0 },
          { name: '徐州恒清食品科技有限公司中小学食堂改造（一标段）', labor: 1, professional: 1, material: 3, consulting: 1 },
          { name: '徐州恒清食品科技有限公司中小学食堂改造（二标段）', labor: 1, professional: 0, material: 5, consulting: 1 },
          { name: '徐州市铜山一中1-2层食堂装修改造工程', labor: 1, professional: 0, material: 3, consulting: 1 },
          { name: '徐州张集中专食堂装修改造', labor: 2, professional: 1, material: 13, consulting: 2 },
          { name: '徐州汉御花园商业楼A区改造项目', labor: 3, professional: 0, material: 2, consulting: 1 },
          { name: '4#楼2层就餐区改造及装修', labor: 3, professional: 0, material: 6, consulting: 1 },
          { name: '徐州梁堂白桥水库', labor: 1, professional: 0, material: 6, consulting: 0 },
          { name: '2019-1号地块2#楼5-11层改造及装修工程', labor: 1, professional: 1, material: 11, consulting: 2 },
          { name: '徐州梁堂民宿项目二期', labor: 5, professional: 0, material: 13, consulting: 0 },
          { name: '徐州柳润建设苗木采购工程', labor: 1, professional: 0, material: 1, consulting: 0 },
          { name: '康养园维修改造工程', labor: 2, professional: 0, material: 5, consulting: 1 },
          { name: '徐州大学路实验学校西地块铁皮围挡', labor: 1, professional: 0, material: 2, consulting: 0 },
          { name: '徐州娇山湖北片区3号地块、风河路南地块围墙', labor: 1, professional: 0, material: 1, consulting: 1 },
          { name: '大彭镇大彭村、义安村搬迁安置项目室外附属项目', labor: 1, professional: 0, material: 3, consulting: 1 },
          { name: '徐州青年创业大厦园区装修及改造工程', labor: 0, professional: 0, material: 6, consulting: 0 },
          { name: '天禄大厦5-7层主水主电改造工程项目', labor: 0, professional: 0, material: 1, consulting: 0 },
          { name: '潍坊疏港高速', labor: 0, professional: 0, material: 1, consulting: 1 },
          { name: '综合楼调度中心冷库机组及材料采购', labor: 0, professional: 0, material: 1, consulting: 0 },
          { name: '红杉树庄园四合院翻新改造', labor: 1, professional: 0, material: 1, consulting: 0 },
          { name: '徐州北京路临时停车场', labor: 1, professional: 0, material: 1, consulting: 0 },
          { name: '徐州铜山摩卡咖啡店装修改造', labor: 0, professional: 0, material: 1, consulting: 0 },
          { name: '徐州铜山南洋国际硕丰超市改造', labor: 0, professional: 0, material: 1, consulting: 1 },
          { name: '民主南路、铜山汽车客运站', labor: 0, professional: 3, material: 0, consulting: 1 },
          { name: '徐州硕立房地产开发有限公司2019-36、37号地块建设项目', labor: 4, professional: 1, material: 15, consulting: 3 },
          { name: '徐州硕源交投建设有限公司XT2023-18号地块建设项目', labor: 3, professional: 0, material: 14, consulting: 1 },
          { name: '徐州硕源交投建设有限公司XT2023-18号地块建设项目城市展厅', labor: 0, professional: 0, material: 4, consulting: 0 }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
